export const formatDateString = (val) => {
    if (typeof val == "object") {
        let year = `${val.getFullYear()}`;
        let month = (val.getMonth() >= 9) ? (`${val.getMonth() + 1}`) : (`0${val.getMonth() + 1}`);
        let date = (val.getDate() >= 9) ? (`${val.getDate()}`) : (`0${val.getDate()}`);
        return `${year}-${month}-${date}`
    } else if (typeof val == "string") {
        return val;
    }
}
export const dateStrToMs = (time) => {
    if (typeof time == "string") {
        let arr = time.split("-");
        return new Date(`${arr[0]}/${arr[1]}/${arr[2]}`).getTime();
    } else if (typeof time == "object") {
        return time.getTime();
    }
}
export const dateStrToMs1= (time) => {
    if (typeof time == "string") {
        let arr = time.split("/");
        return new Date(`${arr[0]}/${arr[1]}/${arr[2]}`).getTime();
    } else if (typeof time == "object") {
        return time.getTime();
    }
}
export const nowDateToNowStr = () => {
    let myDate = new Date();
    return `${myDate.getFullYear()}-${myDate.getMonth() + 1
        }-${myDate.getDate()}`;
}
export const NumToChinese = (s_) => {
    var _arrayCHNNum = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var _arrayCHNBit = ['', '十', '百', '千'];
    let _numArray = s_.toString().split('');
    if (_numArray.length === 2 && _numArray[0] === '1') {
        _numArray[0] = 'y';
    }
    for (let i = _numArray.length - 1; i >= 0; i--) {
        if (_numArray[i] === '0') {
            _numArray[i] = 'x';
        } else {
            break;
        }
    }
    let _s = '';
    let _bLast0 = false;
    for (let i = 0; i < _numArray.length; i++) {
        if (_numArray[i] === 'x') {
            continue;
        }
        if (_numArray[i] === '0' && _bLast0) {
            _bLast0 = true;
            continue;
        }
        if (_numArray[i] !== 'y') {//delete 1 in ten
            _s += _arrayCHNNum[parseInt(_numArray[i])];
        }
        if (_numArray[i] === '0') {
            _bLast0 = true;
            continue;
        }
        _bLast0 = false;

        _s += _arrayCHNBit[_numArray.length - i - 1];
    }
    return _s;
}

export const testPhone = (phone) => {
    // debugger
    var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    var myreg1 = /^\+\d+ \d+$/ ;
    var myreg2 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/ ;
    // var myreg = /^\+\d+ \d+$/ || /^[1][3,4,5,7,8,9][0-9]{9}$/;
    // var myreg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
    if (myreg.test(phone) ||myreg1.test(phone)||myreg2.test(phone)) {
        return true;
    } else {
        return false;
    }
}

export const filterMultyNum = (phone) => {
    if (phone != "") {
        if (phone.indexOf(" ") == -1) {
            return [phone]
        } else {
            let arr = [];
            let temp = phone.split(" ");
            for (let i in temp) {
                if (temp[i] != "") {
                    arr.push(temp[i]);
                }
            }
            return arr;
        }
    }
    return [phone];
}

export const compareTimeWithNow = (timeCheck) => {
    if (timeCheck != null) {
        let time = new Date(timeCheck);
        let startTime = parseInt(time.getTime() / 1000);
        time = new Date();
        let nowTime = parseInt(time.getTime() / 1000);
        if (nowTime > startTime) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

function isLeapYear(year) {
    return (year % 400 == 0) || (year % 4 == 0 && year % 100 != 0);
}

function getMonthDays(year) {
    return [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
}

export const calcWeek = (time) => {
    let year = null;
    let month = null;
    let days = 0;
    if (typeof time == "string") {
        let arr = time.split("-");
        if (arr.length == 3) {
            year = Number(arr[0]);
            month = Number(arr[1]) - 1;
            days = Number(arr[2]);
        } else {
            return null;
        }
    } else if (typeof time == "object") {
        year = time.getFullYear();
        month = time.getMonth();
        days = time.getDate();
    }

    let monthDayNum = getMonthDays(year);
    let day = (new Date(year, 0, 1)).getDay();
    for (let i = 0; i < month; ++i) {
        days += Number(monthDayNum[i]);
    }
    days += Number(day);
    let week = Math.ceil(days / 7);
    return week;
}





// WEBPACK FOOTER //
// ./src/views/commonEdu.js